import { render } from "./BlFormFieldBoolean.vue?vue&type=template&id=5a65f8d6&scoped=true"
import script from "./BlFormFieldBoolean.vue?vue&type=script&lang=js"
export * from "./BlFormFieldBoolean.vue?vue&type=script&lang=js"

import "./BlFormFieldBoolean.vue?vue&type=style&index=0&id=5a65f8d6&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a65f8d6"]])

export default __exports__